module.exports = __webpack_public_path__ + "media/images/vp/icon.linked-9d6a6dc5962042eb1ab6c6365c630931.png";